<template>
  <div class="portlet light">
    <div class="module-name">PROFILE PARTICIPANT</div>
    <vue-spinner v-if="getLoading"></vue-spinner>
    <div class="portlet-body row" v-else>
      <div class="col-md-3 min100">
        <div class="item-head">
          <div class="item-details">
            <avatar :username="username" v-bind:src="avatar" :size="80" :rounded="true" color="#d09f23" backgroundColor="#eef1f5"></avatar>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="item-details min110">
          <router-link :to="{ name: 'Dashboard Participant', params: { id: $route.params.id }}" tag="a" class="item-name primary-link">{{ username }}</router-link>
          <div class="item-body">Phone: {{ getParticipant.phone_number }}</div>
          <div class="item-body">Email: {{ (getParticipant.profile.email != null) ? getParticipant.profile.email : '-' }}</div>
          <div class="item-body">Organization ID: {{ (getParticipant.organization_id != null) ? getParticipant.organization_id : '-' }}</div>
          <div class="item-body">System ID: <span class="uppercase">{{ getParticipant.system_id }}</span></div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="btn-arrow-link pull-right">
          <a class="text-danger" @click.prevent="showRemoveModal" v-if="getUser.access > 3"><i class="icon-trash black"></i> REMOVE</a> |
          <router-link :to="{ name: 'Participant Edit', params: { id: ($route.params.id != null) ? $route.params.id : '' } }" tag="a" class="text-warning">VIEW|EDIT
            <i class="icon-arrow-right black"></i>
          </router-link>
        </div>
      </div>
    </div>
    <remove-participant-modal
      :participant-id="$route.params.id"
    />
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import Avatar from '@/components/menu/Avatar.vue';
  import {URL} from '@/http-common'
  import {mapGetters, mapActions} from 'vuex';
  import Spinner from '@/components/Spinner';
  import RemoveParticipantModal from "@/components/modals/RemoveParticipantModal";
  export default {

    components: {
      RemoveParticipantModal,
      Avatar,
      'vue-spinner': Spinner
    },

    data () {
      return {
      }
    },

    computed: {
      ...mapGetters([
        'getParticipant', 'getLoading', 'getUser'
        ]),
      avatar: function() {
        return this.getParticipant.avatar ? this.getParticipant.avatar : undefined;
      },
      username() {
        if(this.getParticipant.first_name !== undefined && this.getParticipant.last_name !== undefined) {
          return this.getParticipant.first_name + ' ' + this.getParticipant.last_name
        }

        if(this.getParticipant.name !== undefined) {
          return this.getParticipant.name
        }

        return ''
      }
    },

    methods: {
      showRemoveModal() {
        $('#remove_participant_modal').modal('show');
      }
    }
  }
</script>
<style scoped>
  .min100 {
    min-width: 90px;
    text-align: center;
  }
  .black {
    color: black;
  }
  .min110 {
    min-height: 110px;
  }
  .module-name {
    display:none;
  }
  .primary-link {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// ProfileParticipant.vue?4b8efcfe